/**
 * Client logo marquee — JS fallback ensures scroll even if CSS animation fails.
 */
(function () {
  function initMarquee(root) {
    const runner = root.querySelector('[data-marquee-runner]');
    if (!runner || runner.dataset.marqueeReady === 'true') return;

    const direction = root.dataset.direction === 'ltr' ? 1 : -1;
    const speed = Number(root.dataset.speed) || 40;
    const pixelsPerSecond = Math.max(20, 220 - speed * 4);

    const firstTrack = runner.querySelector('[data-marquee-track]');
    if (!firstTrack) return;

    runner.dataset.marqueeReady = 'true';

    const cssRunning = runner.getAnimations().some((animation) => animation.playState === 'running');
    if (cssRunning) return;

    let trackWidth = firstTrack.getBoundingClientRect().width;
    let offset = direction === -1 ? 0 : -trackWidth;
    let lastTime = performance.now();

    const resizeObserver = new ResizeObserver(() => {
      trackWidth = firstTrack.getBoundingClientRect().width;
    });
    resizeObserver.observe(firstTrack);

    runner.style.animation = 'none';
    runner.style.transform = 'translate3d(0, 0, 0)';

    function tick(now) {
      const delta = (now - lastTime) / 1000;
      lastTime = now;

      offset += direction * pixelsPerSecond * delta;

      if (direction === -1 && offset <= -trackWidth) {
        offset += trackWidth;
      } else if (direction === 1 && offset >= 0) {
        offset -= trackWidth;
      }

      runner.style.transform = `translate3d(${offset}px, 0, 0)`;
      requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  function initAll() {
    document.querySelectorAll('[data-matcha-client-logos]').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-matcha-client-logos]');
    if (root) initMarquee(root);
  });
})();
